import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Swiper from 'react-id-swiper';
import axios from 'axios';
import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next"; 

import ls from "local-storage"; 
import { options } from "../../config/options";
//import {creditimg} from "../../assets/img/sub-3.png";
const scratchcard=require('../../assets/img/scratchcard.png');
const wallet=require('../../assets/img/wallet_img.png');
const braintree=require('../../assets/img/braintree.png');


class PaymentOptions extends Component { 
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
          this.paywallet = this.paywallet.bind(this);
        this.homeLink = this.homeLink.bind(this);   

            // const  {myData}  = this.props;
   
   // console.log("PAY TYPE="+this.props.location.paytype.type);

     
        this.state = {
           api_url:localStorage.getItem('api_url'),
             showNav3: false,user_details:'',
             pay_url:'',
             payment_type:'',
             lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'), 
            suc_cls:'',
            message:'',
            modal:'',
             disabled : false
             

        }

    }
     showModal4(modal) {
        this.setState({
            [modal]: true,
            activeTab: '4'
        });
    }
     closeModal(tabId) {
        this.setState({
            [tabId]: false
        });
        this.props.history.push("/app"); 
        window.location.reload();
    }
     homeLink() { 
        this.props.history.push("/app");  
        
        window.location.reload();
    }

      addDefaultSrc(ev){
          ev.target.src =  require('../../assets/img/howzu-logo-default.png')
        }
    componentDidMount(){
    
        if(!this.props || this.props.location.paytype===undefined){
         this.props.history.push("/app/Profile"); 
         return false;
        }
        console.log('pay_type',this.props.location.paytype);
        const payment_type=this.props.location.paytype.type ?this.props.location.paytype.type:"";
        
         this.setState({
            payment_type:payment_type
         });

           console.log("PAY TYPE1="+payment_type);
         if(payment_type=='premium'){
             this.setState({
                       pay_url:'/app/Payment'
                    });
        }
        else if(payment_type=='boost'){
             this.setState({
                       pay_url:'/app/Boostpayment'
                    });
        }
        else if(payment_type=='superlike'){
             this.setState({
                       pay_url:'/app/Superlikepayment'
                    });
        }
       
        
      
    }
      componentWillUnmount() { 
        console.log("component willunmount called");
        //this.props.history.goForward(); 
      }


    
    paywallet(){

      
        if (this.state.disabled) {
        return;
    }
    this.setState({disabled: true});
             var datalist = new FormData();   
          datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
  datalist.set('language', this.state.langKey);              
  datalist.set('purchase_type', this.state.payment_type); 
          if(this.state.payment_type=='premium'){
            datalist.set('id', JSON.parse(localStorage.getItem('selected_premium'))); 
          }
          else if(this.state.payment_type=='boost'){
             datalist.set('id', JSON.parse(localStorage.getItem('selected_boostpremium'))); 
          }
          else if(this.state.payment_type=='superlike'){
             datalist.set('id', JSON.parse(localStorage.getItem('selected_superlikepremium'))); 
          }
          
         // alert("paywallet function");
          axios({
            method: 'post',
            url: this.state.api_url+'paywallet',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
             }}
              }).then(res => {
                if(res.data.status === 'true') {
                      
                    // console.log(res.data);return false;
                  
                    if(res.data.message == "Premium subscription was activated successfully")
                    {
                        this.setState({
                            message: res.data.message});
                            this.setState({ modal4: true });
                           this.showModal4.bind(this, 'modal4')
                           localStorage.setItem('premium_popup', '1');
                          localStorage.setItem('isrevealed', res.data.revealed_matches);
                          this.props.history.push("/app/Profile") 
                    }
                    else{

                    this.setState({
                        message: res.data.message});
                        this.setState({ modal4: true });
                       this.showModal4.bind(this, 'modal4')
                       
                    }

                    
                } else {
                    //alert(res.data.message);
                     this.setState({
                 message: res.data.message});
                      this.setState({ modal4: true });
                this.showModal4.bind(this, 'modal4')
                    //this.props.history.push("/login");   
                }
        }).catch(error => {
           this.props.history.push("/login"); 
        });
    }
    render() {
        

        var package_id;
        var price;
        var currency;
          if(this.state.payment_type=='premium'){
            package_id = JSON.parse(localStorage.getItem('selected_premium')); 
            price = JSON.parse(localStorage.getItem('premium_price')); 
            currency=JSON.parse(localStorage.getItem('currency')); 
            console.log("selected_premiumm="+package_id+price+currency);
          }
          else if(this.state.payment_type=='boost'){
            //  datalist.set('id', JSON.parse(localStorage.getItem('selected_boostpremium'))); 
            package_id = JSON.parse(localStorage.getItem('selected_boostpremium'));
              price = JSON.parse(localStorage.getItem('boostpremium_price')); 
            currency=JSON.parse(localStorage.getItem('currency')); 
            console.log("selected_premium="+package_id+price+currency);
          }
          else if(this.state.payment_type=='superlike'){
            //  datalist.set('id', JSON.parse(localStorage.getItem('selected_superlikepremium'))); 
             package_id = JSON.parse(localStorage.getItem('selected_superlikepremium'));
            price = JSON.parse(localStorage.getItem('superlikepremium_price')); 
            currency=JSON.parse(localStorage.getItem('currency')); 
            console.log("selected_premium="+package_id+price+currency);
          }

        return (

            <div className="setting-page">

               <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
                    <div class="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <div className="iconHolder align-self-center mr-1">
                                <div className="backGlow  d-block d-lg-none">
                                    <div className="sideBarToggler sidebarIcoPos" onClick={() => this.setState({ showNav3: true })}></div>
                                </div>
                            </div>
                        </div>
                        <span class="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Payment Options">Payment Options</Trans></span> 
                    </div>
                    <div className="backGlow white-bg"></div>
                </div> 
               

                <div className="container payment-container">
               
                    {/*<div className="options"> 
                     <NavLink to={{
                      pathname:'/app/scratchcard',
                      paytype:{type:this.state.payment_type},
                      package_id:{package_id:package_id}
                     }}> 
                    <img src={scratchcard} alt="" className="options_img" />
                    <div className="content"><Trans i18nKey="Scratch card">Scratch card</Trans></div>
                      </NavLink>
                    </div>*/}
                     <div className="options" onClick={this.paywallet} disabled={this.state.disabled} style={{'cursor':'pointer'}}> 
                    <img src={wallet} alt="" className="options_img" />
                    <div className="content"><Trans i18nKey="Wallet">Wallet</Trans></div>
                    </div>
                    
                     <div className="options"> 
                    
                       <NavLink to={{
                      pathname:this.state.pay_url,
                      package_id:package_id,
                      currency:currency,
                      price:price
                     }}> 
                    <img src={braintree} alt="" className="options_img" />
                    <div className="content"><Trans i18nKey="Braintree">Braintree</Trans></div>
                    </NavLink>
                    </div>

                    {console.log('pay_url',this.state.pay_url)}
                    

               
                
                </div>

                  <Modal isOpen={this.state.modal4} toggle={this.closeModal.bind(this, 'modal4')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal4')}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal>
                  <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() => this.setState({ showNav3: false })} title={<div></div>} items={[<SideBar />]} />
                </div>





               





            </div>
        )
    }
}

export default withTranslation("translations")(PaymentOptions);